export enum ratingTypes {
  CREDIT_RATING = 'credit-rating',
  CREDIT_REVIEW = 'credit-review',
  ESG_IMPACT = 'esg-impact',
  SENTIMENT = 'sentiment',
  CLIMATE_STRESS_TEST = 'climate-stress-test',
  FUNDS = 'funds',
}
